export const InsuranceQueryKey = 'insurance'
export const Insurance = '/api/v1/insurance'
export const EligibleInsurancesQueryKey = 'eligible-insurances'
export const EligibleInsurances = '/api/v1/insurance-eligibility'
